import gql from 'graphql-tag';

export const ImageFragment = gql`
	fragment ImageFragment on Image {
		asset {
			url
			altText
		}
	}
`;

export const LinkFragment = gql`
	fragment LinkFragment on Link {
		url
		linkText
		openInNewTab
		icon {
			...ImageFragment
		}
	}
	${ImageFragment}
`;

export const UrlCtaFragment = gql`
	fragment UrlCtaFragment on UrlCta {
		url
		linkText
		openInNewTab
	}
`;

export const CustomAlertFragment = gql`
	fragment CustomAlertFragment on CustomAlert {
		showAlert
		alertType
		alertMessage
		alertHeading
		alertCTA {
			...UrlCtaFragment
		}
	}
	${UrlCtaFragment}
`;

export const FooterDisclaimerItemFragment = gql`
	fragment FooterDisclaimerItemFragment on FooterDisclaimer {
		shared {
			content: contentRaw
		}
		custom: customRaw
	}
`;
